var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgImageIcon = function SvgImageIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29.1666668px",
    height: "25px",
    viewBox: "0 0 29.1666668 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.15.4-Setup-/-Location-/-Create-new-location-/-Step-1---clinic-tag",
    transform: "translate(-566.416667, -679.500000)",
    fill: "#666666"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04.Organisms/03.Input-&-Dropdown/01.Without-discription-Copy-5",
    transform: "translate(516.000000, 624.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Body",
    transform: "translate(0.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(45.000000, 20.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.4166666,7.49999994 L9.58333328,7.49999994 C7.28318798,7.5025116 5.41917826,9.36652133 5.41666659,11.6666666 L5.41666659,28.3333334 C5.41917826,30.6334787 7.28318798,32.4974884 9.58333328,32.4999999 L30.4166666,32.4999999 C32.716812,32.4974884 34.5808217,30.6334787 34.5833334,28.3333334 L34.5833334,11.6666666 C34.5808217,9.36652133 32.716812,7.5025116 30.4166666,7.49999994 L30.4166666,7.49999994 Z M25.2083334,11.6666666 C26.9342232,11.6666666 28.3333334,13.0657768 28.3333334,14.7916666 C28.3333334,16.5175565 26.9342232,17.9166667 25.2083334,17.9166667 C23.4824435,17.9166667 22.0833333,16.5175565 22.0833333,14.7916666 C22.0851276,13.0665205 23.4831872,11.6684609 25.2083334,11.6666666 L25.2083334,11.6666666 Z M9.58333328,30.4166667 C8.43274005,30.4166667 7.49999994,29.4839266 7.49999994,28.3333334 L7.49999994,23.9303386 L13.6744791,18.4420573 C14.9109876,17.3454085 16.7871646,17.3995839 17.9583333,18.5657552 L22.186849,22.7851563 L14.5553385,30.4166667 L9.58333328,30.4166667 Z M32.5000001,28.3333334 C32.5000001,29.4839266 31.56726,30.4166667 30.4166667,30.4166667 L17.5019531,30.4166667 L25.4069011,22.5117188 C26.5626053,21.528889 28.259131,21.5244853 29.4199219,22.5013021 L32.5000001,25.0677084 L32.5000001,28.3333334 Z",
    id: "image"
  }))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgImageIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/image-icon.eff04b3b.svg";
export { ForwardRef as ReactComponent };